<template>
  <div class="app-container">
    <el-form
      :model="queryParams"
      ref="queryFormRef"
      :inline="true"
      label-width="90px"
    >
      <el-form-item label="IP 地址" prop="ipAddress">
        <el-input
          v-model="queryParams.ipAddress"
          placeholder="请输入访问 IP 地址"
          clearable
          style="width: 240px"
          @keyup.enter="handleQuery"
        />
      </el-form-item>
      <el-form-item label="访问位置" prop="visitLocation">
        <el-input
          v-model="queryParams.visitLocation"
          placeholder="请输入访问位置"
          clearable
          style="width: 240px"
          @keyup.enter="handleQuery"
        />
      </el-form-item>
      <el-form-item label="浏览器类型" prop="browserType">
        <el-input
          v-model="queryParams.browserType"
          placeholder="请输入浏览器类型"
          clearable
          style="width: 240px"
          @keyup.enter="handleQuery"
        />
      </el-form-item>
      <el-form-item label="操作系统" prop="operateSystem">
        <el-input
          v-model="queryParams.operateSystem"
          placeholder="请输入操作系统"
          clearable
          style="width: 240px"
          @keyup.enter="handleQuery"
        />
      </el-form-item>
      <el-form-item label="访问用户" prop="visitUser">
        <el-input
          v-model="queryParams.visitUser"
          placeholder="请输入访问用户名或昵称"
          clearable
          style="width: 240px"
          @keyup.enter="handleQuery"
        />
      </el-form-item>
      <el-form-item label="访问时间" style="width: 330px">
        <el-date-picker
          v-model="dateRange"
          value-format="YYYY-MM-DD"
          format="YYYY-MM-DD"
          type="daterange"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="Search" @click="handleQuery"
          >搜索</el-button
        >
        <el-button icon="Refresh" @click="handleResetQuery">重置</el-button>
      </el-form-item>
    </el-form>

    <el-table border v-loading="loading" :data="dataList">
      <el-table-column label="访问编号" align="center" prop="id" width="180" />
      <el-table-column
        label="访问 IP 地址"
        prop="ipAddress"
        :show-overflow-tooltip="true"
      />
      <el-table-column
        label="访问位置"
        prop="visitLocation"
        :show-overflow-tooltip="true"
      />
      <el-table-column
        label="浏览器类型"
        prop="browserType"
        :show-overflow-tooltip="true"
      />
      <el-table-column
        label="操作系统"
        prop="operateSystem"
        :show-overflow-tooltip="true"
      />
      <el-table-column label="访问时间" align="center" width="160">
        <template #default="{ row }">
          <span>{{ parseTime(row.gmtVisit) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="访问用户" :show-overflow-tooltip="true">
        <template #default="{ row }">
          <span v-if="row.username"
            >{{ row.nickName }}({{ row.username }})</span
          >
        </template>
      </el-table-column>
    </el-table>

    <pagination
      v-show="totalCount > 0"
      :total="totalCount"
      v-model:page="queryParams.pageNum"
      v-model:limit="queryParams.pageSize"
      @pagination="getPage"
    />
  </div>
</template>
<script setup>
import { getCurrentInstance, ref } from 'vue'

import { page } from '@/api/nav/log/visit'

const { proxy } = getCurrentInstance()

const loading = ref(true)
const dataList = ref([])
const totalCount = ref(0)
const dateRange = ref([])

const queryParams = ref({
  pageNum: 1,
  pageSize: 10,
  ipAddress: undefined,
  visitLocation: undefined,
  browserType: undefined,
  operateSystem: undefined,
  visitUser: undefined,
  beginGmtVisit: undefined,
  endGmtVisit: undefined
})

/**
 * 获取数据
 */
async function getPage() {
  loading.value = true
  queryParams.value.beginGmtVisit = undefined
  queryParams.value.endGmtVisit = undefined
  if (Array.isArray(dateRange.value) && dateRange.value.length === 2) {
    queryParams.value.beginGmtVisit = dateRange.value[0] + ' 00:00:00'
    queryParams.value.endGmtVisit = dateRange.value[1] + ' 23:59:59'
  }
  const {
    data: { total, list }
  } = await page(queryParams.value)
  totalCount.value = parseInt(total)
  dataList.value = list
  loading.value = false
}

/**
 * 搜索
 */
function handleQuery() {
  getPage()
}

/**
 * 重置
 */
function handleResetQuery() {
  proxy.resetForm('queryFormRef')
  dateRange.value = undefined
  handleQuery()
}

/**
 * 初始化
 */
getPage()
</script>
